import JSEncrypt from 'jsencrypt'
import axios from 'axios'

import aesjs from 'aes-js'

const randHex = function (len) {
  const maxlen = 8
  const min = Math.pow(16, Math.min(len, maxlen) - 1)
  const max = Math.pow(16, Math.min(len, maxlen)) - 1
  const n = Math.floor(Math.random() * (max - min + 1)) + min
  let r = n.toString(16)
  while (r.length < len) {
    r = r + randHex(len - maxlen)
  }
  return r
}

axios.defaults.timeout = 2500

const Session = function () {
  this.key = false
  this.iv = false
  this.sessionId = false
  this.count = 0

  this.increase = () => {
    this.count++
  }

  this.getCount = () => {
    return this.count
  }

  this.counter = () => {
    return this.cipher(this.count, true)
  }

  this.genKey = () => {
    this.key = randHex(64)
    return this.key
  }

  this.genIv = () => {
    this.iv = randHex(32)
    return this.iv
  }

  this.setSessionId = (sessionId) => {
    this.sessionId = sessionId
  }

  this.cipher = (data, asString = false) => {
    let string = ''
    if (asString) string = data
    else string = JSON.stringify(data)
    // console.log('cipher obj, string', data, string)
    const stringBytes = aesjs.utils.utf8.toBytes(string)
    const paddedStringBytes = aesjs.padding.pkcs7.pad(stringBytes)
    const encryptAesCfb = new aesjs.ModeOfOperation.cbc(aesjs.utils.hex.toBytes(this.key), aesjs.utils.hex.toBytes(this.iv))
    const encryptedBytes = encryptAesCfb.encrypt(paddedStringBytes)
    return aesjs.utils.hex.fromBytes(encryptedBytes)
  }

  this.data = (cipher) => {
    try {
      const encryptedBytes = aesjs.utils.hex.toBytes(cipher)
      const decryptAesCfb = new aesjs.ModeOfOperation.cbc(aesjs.utils.hex.toBytes(this.key), aesjs.utils.hex.toBytes(this.iv))
      const decryptedBytes = decryptAesCfb.decrypt(encryptedBytes)
      const strippedDecryptedBytes = aesjs.padding.pkcs7.strip(decryptedBytes)
      const string = aesjs.utils.utf8.fromBytes(strippedDecryptedBytes)
      try {
        return JSON.parse(string)
      } catch (e) {
        return string
      }
    } catch (e) {
      console.log('[secure.js] error in decription, recieved:', cipher)
      console.log('    | -> error:', e)
    }
    return false
  }
}

export default {
  getApiSession (address, interfaceId, password) {
    return new Promise((resolve, reject) => {
      const session = new Session()
      if (address) {
        const url = 'http://' + address + '/auth/pubkey'
        axios.get(url)
          .then((response) => {
            if (response && response.data && response.data) {
              const pem = response.data

              try {
                const data = {
                  key: session.genKey(),
                  iv: session.genIv(),
                  interfaceId,
                  pass: password
                }
                const dataString = JSON.stringify(data)

                const encrypt = new JSEncrypt()
                encrypt.setPublicKey(pem)

                const encryptedData = encrypt.encrypt(dataString)

                const url = 'http://' + address + '/session/new'

                const options = {
                  method: 'post',
                  data: encryptedData,
                  headers: { 'Content-Type': 'text/plain' },
                  url
                }

                axios(options)
                  .then((response) => {
                    if (response.data && response.data.sessionId) {
                      const sessionId = response.data.sessionId
                      session.setSessionId(sessionId)
                      resolve(session)
                    } else {
                      const e = 'invalid response set session'
                      reject(e)
                    }
                  })
                  .catch((e) => {
                    console.log('axios error', e)
                    reject(e)
                  })
              } catch (e) {
                reject(e)
              }
            } else {
              const e = {
                msg: 'invalid response for public key',
                data: response.data
              }
              reject(e)
            }
          })
          .catch((e) => {
            reject(e)
          })
      } else {
        const e = 'no address or type'
        reject(e)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/secure.js